// @flow
import { combineActions, handleActions, createActions } from 'redux-actions'

export type FilterType = {
  numberOfResults: number,
  isSortedAscending: boolean,
  lookupString: string
}

export const { showMoreLines, showLessLines } = createActions({
  SHOW_MORE_LINES: amount => ({ amount }),
  SHOW_LESS_LINES: amount => ({ amount: -amount })
})

export const { lookupString, flipSortOrder } = createActions(
  'LOOKUP_STRING',
  'FLIP_SORT_ORDER'
)

export const filter: FilterType = handleActions(
  {
    [combineActions(showMoreLines, showLessLines)] (
      state,
      { payload: { amount } }
    ) {
      return {
        ...state,
        numberOfResults: state.numberOfResults + amount
      }
    },
    LOOKUP_STRING: (state, action) => {
      return {
        ...state,
        lookupString: action.payload
      }
    },
    FLIP_SORT_ORDER: state => {
      return {
        ...state,
        isSortedAscending: !state.isSortedAscending
      }
    }
  },
  {
    numberOfResults: 10,
    isSortedAscending: true,
    lookupString: ''
  }
)

export default filter



// WEBPACK FOOTER //
// ./src/components/municipalitySearch/reducer.js